<template>
    <div>
        <b-card body-class="p-0">
            <b-card-header>
                <h5 class="mb-0">
                    <font-awesome-icon
                        v-if="creatorGallery?.medias?.length"
                        class="text-primary"
                        icon="fa-solid fa-check-circle"
                    />
                    <font-awesome-icon
                        v-else
                        icon="fa-solid fa-circle"
                    ></font-awesome-icon>
                    {{ $t("Content") }}
                </h5>
            </b-card-header>
            <b-card-body>
                <b-alert variant="warning" show>
                    <b-table-simple bordered class="mb-0">
                        <tbody>
                            <tr>
                                <th class="bg-light align-middle">
                                    <h5 class="mb-0">
                                        {{ $t("Authenticity Code") }}
                                    </h5>
                                    <div class="small text-warning">
                                        {{ $t("Required with your content") }}
                                    </div>
                                </th>
                                <td class="bg-white text-center">
                                    <h1 class="mb-0 text-warning">
                                        {{ creatorGallery.authenticityCode }}
                                    </h1>
                                </td>
                            </tr>
                        </tbody>
                    </b-table-simple>

                    <b-button
                        class="mt-3"
                        v-b-toggle.howThisWorks
                        variant="light"
                        pill
                        block
                    >
                        <font-awesome-icon icon="fa-duotone fa-info-circle" />
                        {{ $t("How authenticity code works?") }}
                    </b-button>
                    <b-collapse id="howThisWorks">
                        <div class="mt-3">
                            <h5 class="mt-3">
                                {{
                                    $t(
                                        "Verify content ownership by including a code or showing your face"
                                    )
                                }}
                            </h5>
                            {{
                                $t(
                                    "We only accept authentic content belonging to the creator for galleries. We recommend to include the provided code in your content to guarantee approval or show your face"
                                )
                            }}
                        </div>

                        <h5 class="mt-3">
                            {{ $t("How to include the code?") }}
                        </h5>
                        {{
                            $t(
                                "Be creative... You can say the code in a video, or hold up a piece of paper showing the code in a photo so we know its really you. We just need to somehow see or hear that code to know its legit. You can have fun with the code verification and come up with unique new ways to include it that give the customers confidence in their purchase"
                            )
                        }}

                        <h5 class="mt-3">
                            {{
                                $t(
                                    "What if my gallery does not include the code?"
                                )
                            }}
                        </h5>
                        {{
                            $t(
                                "If your face is not clearly showing in your content so that we can identify it belongs to you, we may not be able to accept your content if it does not include a code. We have a very strict no fake content policy, and unless we are certain the content is yours we will not publish it"
                            )
                        }}

                        <div class="mt-2">
                            <font-awesome-icon
                                icon="fa-solid fa-ban"
                                class="text-danger"
                            />
                            {{
                                $t(
                                    "Submitting content that does not belong to you may result in fines or a ban"
                                )
                            }}
                        </div>
                    </b-collapse>
                </b-alert>

                <div class="mt-2">
                    <creator-gallery-media />
                </div>

                <div class="mt-2 text-center" v-if="creatorGallery.editable">
                    <creator-gallery-upload>
                        <b-btn variant="primary" pill size="lg" class="px-4">
                            <font-awesome-icon
                                class="mr-1"
                                icon="fa-light fa-plus"
                            />
                            {{ $t("Upload") }}
                        </b-btn>
                    </creator-gallery-upload>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import { mapState } from "vuex";

import CreatorGalleryMedia from "@/components/creator/gallery/CreatorGalleryMedia";
import CreatorGalleryUpload from "@/components/creator/gallery/CreatorGalleryUpload";

export default {
    computed: {
        hasMediaItems() {
            return this.creatorGallery?.medias?.length > 0;
        },
        ...mapState("creatorGallery", ["creatorGallery"]),
    },
    components: {
        CreatorGalleryUpload,
        CreatorGalleryMedia,
    },
};
</script>